import { timeLineSlice } from '../reducers/timeLineSlice';
import { getStore } from '../store';

type timeLineSpinnerActionType = 'timeLine/setShowSpinner' | 'timeLine/setReverseAnimation';

export const timeLineProvider = (): {
  setShowSpinner: (timeLineSpinner: boolean) => { payload: boolean; type: timeLineSpinnerActionType };
  setReverseAnimation: (reverseAnimation: boolean) => { payload: boolean; type: timeLineSpinnerActionType };
} => {
  const { dispatch } = getStore();
  const { setReverseAnimation, setShowSpinner } = timeLineSlice.actions;
  return {
    setShowSpinner: (showSpinner: boolean): { payload: boolean; type: timeLineSpinnerActionType } =>
      dispatch(setShowSpinner(showSpinner)),
    setReverseAnimation: (reverseAnimation: boolean): { payload: boolean; type: timeLineSpinnerActionType } =>
      dispatch(setReverseAnimation(reverseAnimation)),
  };
};
